import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const fcssSection = document.querySelectorAll('.featured-case-studies-section');

    fcssSection.forEach(section => {
        const fcssSldier = section.querySelector('.fcss-slider');

        if (fcssSldier) {
            new Swiper(fcssSldier, {
                slidesPerView: 1,
                spaceBetween: 32,
                autoHeight: true,
                effect: 'fade',
                allowTouchMove: true,
                noSwiping: true,
                noSwipingClass: 'no-swiping',
                fadeEffect: {
                    crossFade: true,
                },
                navigation: {
                    prevEl: fcssSldier.parentNode.querySelector('.fcss-button-prev'),
                    nextEl: fcssSldier.parentNode.querySelector('.fcss-button-next'),
                },
            });
        }
    });
});